<template>
    <div>111
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加颜色' }"  > 添加
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" > 排序</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='修改行业'; editId=text.id ; }"  >编辑 <a-divider  type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a  >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <ColorForm :visible="visibleForm" :title="titleForm" :editId="editId"
                      @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
    </div>

</template>

<script>
    import API from "./api";
    import ColorForm from "./components/colorForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            ellipsis: true,
            key: "list_order",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "颜色",
            key: "name", 
            dataIndex: "name",
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                columns,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/TemplateManagement/ColorManagement"; //设置左侧导航2-2 active
        },
        components: {ColorForm},
        methods: {
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                orderList(API.service.LIST_ORDER, list_orders).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

            getList(page) {
                API.service.GET_LIST(page||1).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.loading = false
                })
            },
            confirm(row) {
                removeById(API.service.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>